'use strict';

angular.module('v-tv-package').provider('tvPackageConfig', function (appConfigProvider) {
    var key = 'angular-app-v-tv-package';

    this.appConfig = angular.merge({ i18n: {} }, appConfigProvider.$get()[key]);

    this.$get = function () {
        return this.appConfig;
    };
});